<template>
    <NuxtPage />
</template>

<script lang="ts" setup>

throw createError({
    status: 404,
    fatal: true,
})

</script>

<style lang="scss" scoped>

</style>
